import { render, staticRenderFns } from "./FilterMedications.vue?vue&type=template&id=0bd97fda&scoped=true&lang=pug&"
import script from "./FilterMedications.vue?vue&type=script&lang=js&"
export * from "./FilterMedications.vue?vue&type=script&lang=js&"
import style0 from "./FilterMedications.vue?vue&type=style&index=0&id=0bd97fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd97fda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VIcon,VMenu,VSkeletonLoader,VSpacer,VTextField})
